export default {
    name: 'InputText',

    data() {
        return {
            error: '',
            clear: ''
        }
    },

    props: {
        type: String,
        label: String,
        required: Boolean,
        search: Boolean,
        placeholder: String,
        value: String | Number,
        disabled: Boolean,
        min: Number,
        max: Number,
        pattern: String,
        isLicencePlate: false,
        showClear: false
    },

    mounted() {
         this.clear = this.value != '' && this.value != undefined && !this.showClear? 'input-text-clear' : ''
    },

    methods: {
        updateValue(value) {
            this.clear = value != '' && !this.showClear ? 'input-text-clear' : ''
            this.$emit('input', this.type == "number" ? Number(value) : value)
        },

        submit() {
            this.$refs.inputText.blur()
            this.$emit('submit')
        },

        validLicencePlate(lp) {
            if (lp == undefined) {
                return true
            } else {
                let regex = RegExp("^[A-Z0-9]*$")
                return regex.test(lp)
            }

        },

        checkForError() {
            if (typeof this.value != 'number') { // needs additional checking if number
                this.error = this.value || !this.required ? '' : 'input-text-error'
            } else {
                if (this.value == 0 || this.value == 1) { // because numbers 0 and 1 are also bools
                    this.error = ''
                } else {
                    this.error = this.value || !this.required ? '' : 'input-text-error'
                }
            }

            if (this.min != undefined && this.max != undefined) {
                if (this.value < this.min || this.value > this.max || this.max <= this.min) {
                    this.error = 'input-text-error'
                }
            }
            if (this.isLicencePlate)  this.value = this.value?.toUpperCase()
            if (this.isLicencePlate && !this.validLicencePlate(this.value)) {
                this.error = 'input-text-error'
            }
            if ( this.pattern != undefined ) {
                if ( this.pattern.length != 0 ) {
                    if (!RegExp(this.pattern).test(this.value)) {
                        this.error = 'input-text-error'
                    }
                }
            }
            return this.error
        },

        doClear() {
            this.clear = ''
            this.$emit('clear')
            this.$refs.inputText.focus()
        }
    }
}
